<div>

    <div class="card6 shadow gap-4 flex">

        <div class="row d-flex">
            <div class="col-lg-3   custom-input-container">
                <div class="iconGrid">
                    <i [size]="18" data-feather="layers"></i>
                </div>
                <div class="flex-grow-1 min-w-0">
                    <div class="text-xs text-gray-500 size13">Emplacement</div>
                    <ng-select
                        name="emplacementFilter"
                        class="emplacement-ng-select mt-1"
                        [items]="entrepotsList"
                        bindLabel="nom"
                        bindValue="id"
                        placeholder="Tous les entrepôts"
                        notFoundText="Aucun entrepôt"
                        [searchable]="true"
                        [clearable]="true"
                        [loading]="isLoadingEntrepots"
                        appendTo="body"
                        [(ngModel)]="selectedEntrepotId"
                        (change)="onEntrepotFilterChange()"
                    >
                    </ng-select>
                </div>
            </div>

            <div class="col-lg-3   custom-input-container">
                <div class="icondollar">
                    <i [size]="18" data-feather="package"></i>
                </div>
                <div>
                    <div class="text-xs text-gray-500 size13">État de stock</div>
                    <div
                        class="text-sm font-medium size18"
                        [attr.title]="etatStockTitle || null"
                    >{{ etatStockLabel }}</div>
                </div>
            </div>

            <div class="col-lg-3   gap-4 custom-input-container">
                <div class="percent bg-rose-100 ">
                    <i [size]="18" data-feather="arrow-down"></i>
                </div>
                <div [attr.title]="minMaxThresholdsTitle || null">
                    <div class="text-xs text-gray-500 size13">Minimum</div>
                    <div class="text-sm font-medium size18">{{ stockMinLabel }}</div>
                </div>
            </div>

            <div class="col-lg-3   gap-4 custom-input-container">
                <div class="up bg-rose-100 ">
                    <i [size]="18" data-feather="arrow-up"></i>
                </div>
                <div [attr.title]="minMaxThresholdsTitle || null">
                    <div class="text-xs text-gray-500 size13">Maximum</div>
                    <div class="text-sm font-medium size18">{{ stockMaxLabel }}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="row align-items-center" style="margin-bottom: 24px;margin-left: 24px ; margin-top: 24px">
        <div class="col-lg-4 col-md-6 col-sm-12 d-flex align-items-center" style="gap: 10px;flex-wrap: nowrap;">
            <div class="input-group form-password-toggle d-flex" style="max-width: 250px; min-width: 150px;">
                <input type="text" class="form-control search-bar" placeholder="Recherche par mot clé"
                       [value]="searchTerm"
                       (input)="onSearchInput($any($event.target).value)">
                <div class="input-group-append">
        <span class="input-group-text" id="basic-addon-search1" style="color: black; cursor: pointer; background-color: transparent; border-left: none; padding: 0 10px;">
          <i data-feather="search" [size]="20"></i>
        </span>
                </div>

            </div>

            <button class="btn btn-outline-primary btn-icon" (click)="toggleFilter()">
                <i data-feather="filter"></i>
            </button>
            <span class="filter-summary" *ngIf="filterSummary" [title]="filterSummary">{{ filterSummary }}</span>

        </div>

    </div>


    <hr>

    <div *ngIf="loading" class="text-center py-4 text-muted">Chargement des mouvements…</div>
    <div *ngIf="!loading && errorMessage" class="alert alert-warning mb-0" role="alert">{{ errorMessage }}</div>

    <div class="table-responsive mouvement-stock-table-wrap" *ngIf="!loading">
        <table class="table table-hover mouvement-stock-table">
            <thead class="align-middle custom-thead">
            <tr>
                <th>DATE</th>
                <th>DOCUMENT</th>
                <th title="Statut du mouvement (colonne statut)">ÉTAT</th>
                <th>CONTACT</th>
                <th>UTILISATEUR</th>
                <th>QUANTITÉ ENTRANTE</th>
                <th>QUANTITÉ SORTANTE</th>
                <th>EN STOCK</th>
                <th>ENTREPOT</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let m of pagedMouvements">
                <td class="cell-date">{{ m.date }}</td>
                <td class="cell-doc">
                    <ng-container *ngIf="m.documentId">
                        <a
                            class="cell-doc__link"
                            href="javascript:void(0)"
                            (click)="openDocumentInApproveVente(m, $event)"
                            [attr.title]="'Ouvrir le document'"
                        >
                            <span class="cell-doc__ref">{{ m.document }}</span>
                            <ng-container *ngIf="m.documentSub">
                                <br />
                                <small class="cell-doc__sub">{{ m.documentSub }}</small>
                            </ng-container>
                        </a>
                    </ng-container>
                    <ng-container *ngIf="!m.documentId">
                        <span class="cell-doc__ref">{{ m.document }}</span>
                        <ng-container *ngIf="m.documentSub">
                            <br />
                            <small class="cell-doc__sub">{{ m.documentSub }}</small>
                        </ng-container>
                    </ng-container>
                </td>
                <td>
                    <span class="ms-badge" [ngClass]="m.etatBadgeClass">{{ m.etat }}</span>
                </td>
                <td class="cell-muted cell-wrap">{{ getContactDisplay(m) }}</td>
                <td class="cell-muted">{{ getUtilisateurDisplay(m) }}</td>
                <td>
                    <span *ngIf="m.quantiteEntranteHasValue" class="ms-badge ms-badge--success">{{ m.quantiteEntrante }}</span>
                    <span *ngIf="!m.quantiteEntranteHasValue" class="cell-dash">--</span>
                </td>
                <td>
                    <span *ngIf="!m.quantiteSortanteIsEmpty" class="ms-badge ms-badge--out">{{ m.quantiteSortante }}</span>
                    <span *ngIf="m.quantiteSortanteIsEmpty" class="cell-dash">--</span>
                </td>
                <td class="cell-muted">{{ m.enStock }}</td>
                <td class="cell-muted cell-wrap">{{ m.entrepot }}</td>
            </tr>
            <tr *ngIf="!filteredMouvements.length && !errorMessage">
                <td colspan="9" class="text-center text-muted py-4">Aucun mouvement de stock à afficher.</td>
            </tr>
            </tbody>
        </table>
    </div>

    <app-table-pagination-bar
        *ngIf="!loading && filteredMouvements.length"
        [totalItems]="filteredMouvements.length"
        [pageFrom]="paginationFrom"
        [pageTo]="paginationTo"
        [currentPage]="clampedPage"
        [totalPages]="totalPages"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        itemsLabel="mouvement(s)"
        ariaLabel="Pagination des mouvements"
        nameSuffix="mouvement-stock"
        (pageChange)="goToPage($event)"
        (pageSizeChange)="onPaginationPageSizeChange($event)"
    ></app-table-pagination-bar>

</div>
